/* eslint-disable no-param-reassign */
import _ from 'underscore';

// ProductImage - Container for image metadata
export class ProductImage implements MerchantosProductImageModel {
  private dataXmlTemplate: { Image: string; WorkorderImage: string };

  // @ts-expect-error ts-migrate(6133) FIXME: 'type' is declared but its value is never read.
  private type: any;

  private imageType: ImageType;

  public id: MerchantosProductImageModel['id'];

  private filename: string;

  private description: string;

  private publicID: string;

  public itemID: string;

  private workorderID: string;

  private itemMatrixID: string;

  public ordering: MerchantosProductImageModel['ordering'];

  // @ts-expect-error ts-migrate(6133) FIXME: 'url' is declared but its value is never read.
  private url: string;

  public prev: ProductImage | null = null;

  public next: ProductImage | null = null;

  constructor(options: ImageInfo) {
    this.dataXmlTemplate = {
      Image:
        '<Image><imageID/><description/><filename/><ordering/><publicID/><itemID/><itemMatrixID/></Image>',
      WorkorderImage:
        '<WorkorderImage><workorderImageID/><description/><filename/><ordering/><publicID/><workorderID/></WorkorderImage>',
    };

    this.type = options.type!;
    this.imageType = options.imageType!;
    this.id = options.imageID!;
    this.filename = options.filename;
    this.description = options.description;
    this.publicID = options.publicID;
    // @ts-expect-error ts-migrate(2551) FIXME: Property 'itemID' does not exist on type 'ImageInf... Remove this comment to see the full error message
    this.itemID = options.itemID;
    this.workorderID = options.workorderID;
    this.itemMatrixID = options.itemMatrixID;
    this.ordering = options.ordering;
    this.url = '';
    this.init();
  }

  init: MerchantosProductImageModel['init'] = () => {
    const fileParts = this.filename.split('.');
    const extension = fileParts[fileParts.length - 1];
    this.url = $.cloudinary.url(this.publicID, { format: extension, crop: 'fill' });
  };

  getXml: MerchantosProductImageModel['getXml'] = () => {
    const $xml = $($.parseXML(this.dataXmlTemplate[this.imageType]));
    $xml.find('imageID, workorderImageID').text(this.id);
    $xml.find('description').text(this.description);
    $xml.find('filename').text(this.filename);
    $xml.find('publicID').text(this.publicID);
    $xml.find('itemID').text(this.itemID);
    $xml.find('workorderID').text(this.workorderID);
    $xml.find('itemMatrixID').text(this.itemMatrixID);
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    $xml.find('ordering').text(this.ordering);

    return $xml;
  };

  updateOrder: MerchantosProductImageModel['updateOrder'] = order => {
    if (this.ordering != order) {
      this.ordering = order;

      const $imageXml = this.getXml();
      const xmlString = new window.XMLSerializer().serializeToString($imageXml[0]);

      $.ajax({
        url: `/API/Account/${window.merchantos.account.id}/${this.imageType}/${this.id}`,
        type: 'PUT',
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        accepts: 'application/xml',
        data: xmlString,
      });
    }
  };

  getResizedUrl: MerchantosProductImageModel['getResizedUrl'] = cloudinaryOptions => {
    return $.cloudinary.url(this.publicID, cloudinaryOptions);
  };
}

// track images in a doubly-linked, null-terminated list
class ProductImageList implements MerchantosProductImageList {
  public head: MerchantosProductImageList['head'] = null;

  public listSize: MerchantosProductImageList['listSize'] = 0;

  addImage: MerchantosProductImageList['addImage'] = newImage => {
    if (this.head === null) {
      this.head = newImage;
    } else {
      // sort the list based on ordering when adding a new product image
      let currentImage: MerchantosProductImageModel | null = this.head;
      let previousImage: MerchantosProductImageModel | null = null;
      while (currentImage !== null) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        if (newImage.ordering < currentImage.ordering) {
          if (currentImage === this.head) {
            this.head = newImage;
          }

          newImage.prev = currentImage.prev;

          if (newImage.prev !== null) {
            newImage.prev.next = newImage;
          }
          currentImage.prev = newImage;
          newImage.next = currentImage;

          break;
        }

        previousImage = currentImage;
        currentImage = currentImage.next;
      }

      // adding newImage to end of list
      if (currentImage === null) {
        previousImage!.next = newImage;
        newImage.prev = previousImage;
      }
    }
    this.listSize += 1;

    return newImage;
  };

  /**
   * move insertImage, already in the list, to before imageAtInsert
   */
  insertBefore: MerchantosProductImageList['insertBefore'] = (insertImage, imageAtInsert) => {
    if (insertImage !== imageAtInsert && insertImage !== imageAtInsert.prev) {
      if (this.head === insertImage) {
        this.head = insertImage.next;
      } else if (this.head === imageAtInsert) {
        this.head = insertImage;
      }

      if (insertImage.prev !== null) {
        insertImage.prev.next = insertImage.next;
      }
      if (insertImage.next !== null) {
        insertImage.next.prev = insertImage.prev;
      }

      insertImage.prev = imageAtInsert.prev;
      imageAtInsert.prev = insertImage;
      insertImage.next = imageAtInsert;

      if (insertImage.prev !== null) {
        insertImage.prev.next = insertImage;
      }
    }
  };

  /**  move insertImage, already in the list, to after imageAtInsert */
  insertAfter: MerchantosProductImageList['insertAfter'] = (insertImage, imageAtInsert) => {
    if (insertImage !== imageAtInsert && insertImage !== imageAtInsert.next) {
      if (this.head === insertImage) {
        this.head = insertImage.next;
      }

      if (insertImage.next !== null) {
        insertImage.next.prev = insertImage.prev;
      }
      if (insertImage.prev !== null) {
        insertImage.prev.next = insertImage.next;
      }

      insertImage.next = imageAtInsert.next;
      imageAtInsert.next = insertImage;
      insertImage.prev = imageAtInsert;

      if (insertImage.next !== null) {
        insertImage.next.prev = insertImage;
      }
    }
  };

  removeImage: MerchantosProductImageList['removeImage'] = imageId => {
    let currentImage = this.head;
    while (currentImage !== null) {
      if (currentImage.id == imageId) {
        if (this.head === currentImage) {
          this.head = currentImage.next;
        }
        if (currentImage.prev !== null) {
          currentImage.prev.next = currentImage.next;
        }
        if (currentImage.next !== null) {
          currentImage.next.prev = currentImage.prev;
        }
        currentImage = null;
        this.listSize -= 1;
        break;
      }
      currentImage = currentImage.next;
    }
  };
}

/** ProductImages - Model for product images */

export class ProductImages implements MerchantosProductImages {
  private id: string | number;

  private options: {
    type: string;
    imageType: ImageType;
  };

  public images: MerchantosProductImages['images'];

  public imageDict: MerchantosProductImages['imageDict'] = {};

  private imageArray: ImageInfo[] = [];

  constructor(id: string | number, options: Partial<ProductImages['options']>) {
    this.id = id;
    this.options = {
      type: 'Item',
      imageType: 'Image',
      ...options,
    };

    this.images = new ProductImageList();
  }

  fetchProductImages: MerchantosProductImages['fetchProductImages'] = (forceReload?: boolean) => {
    let $deferred = $.Deferred();
    if (this.id) {
      // @ts-expect-error ts-migrate(2740) FIXME: Type 'Promise<JSON, any, any>' is missing the foll... Remove this comment to see the full error message
      $deferred = this.getImageMetadata(forceReload);
    }

    const $deferredReady = $.Deferred();
    $deferred
      .done(
        $.proxy((item: any) => {
          // Item matrix parents don't have item IDs
          if (item.ItemMatrix && !item.itemID) {
            item = item.ItemMatrix;
          }
          if (item.Workorder) {
            item = item.Workorder;
          }

          let images = item.Images && item.Images[this.options.imageType];
          if (images) {
            if (!Array.isArray(images)) {
              images = [images];
            }
            this.setProductImages(images);
          }
        }, this)
      )
      .then(() => {
        $deferredReady.resolve();
      });

    return $deferredReady;
  };

  getImageMetadata: MerchantosProductImages['getImageMetadata'] = (forceReload = false) => {
    let promise;
    if (this.options.type === 'Item') {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
      promise = window.merchantos.itemCaching.load(this.id, forceReload);
    } else {
      // Caching only exists for Items right now
      const url = `/API/Account/${window.merchantos.account.id}/${this.options.type}/${
        this.id
      }?load_relations=${encodeURIComponent('["Images"]')}`;

      promise = window.lsCloud.getJSONFromAPI(url);
    }

    return promise;
  };

  setProductImages: MerchantosProductImages['setProductImages'] = images => {
    this.images = new ProductImageList();
    this.imageArray = images;

    images.forEach(image => {
      this.addProductImage(image);
    });
  };

  addProductImage: MerchantosProductImages['addProductImage'] = (image: ImageInfo) => {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | number | undefined' is not assignab... Remove this comment to see the full error message
    image.id = image.imageID || image.workorderImageID;

    // don't include an Image if it's not stored to Cloudinary
    if (image.publicID !== '') {
      this.imageDict[image.id!] = this.images.addImage(
        new ProductImage({
          type: this.options.type,
          imageType: this.options.imageType,
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
          imageID: image.id,
          filename: image.filename,
          description: image.description,
          publicID: image.publicID,
          // @ts-expect-error ts-migrate(2551) FIXME: Property 'itemID' does not exist on type 'ImageInf... Remove this comment to see the full error message
          itemID: image.itemID,
          workorderID: image.workorderID,
          itemMatrixID: image.itemMatrixID,
          ordering: image.ordering,
        })
      );
    }
  };

  cacheProductImage: MerchantosProductImages['cacheProductImage'] = (image: ImageInfo) => {
    this.imageArray.push(image);
    if (this.options.type === 'Item') {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
      window.merchantos.itemCaching.setImageCache(this.id, this.imageArray);
    }
  };

  removeProductImage: MerchantosProductImages['removeProductImage'] = imageID => {
    let imageToRemove = null;
    delete this.imageDict[imageID];

    this.imageArray.forEach((image, idx) => {
      // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
      if (image.imageID == imageID) {
        imageToRemove = idx;
      }
    });
    if (imageToRemove !== null) {
      this.imageArray.splice(imageToRemove, 1);
      if (this.options.type === 'Item') {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
        window.merchantos.itemCaching.setImageCache(this.id, this.imageArray);
      }
    }

    this.images.removeImage(imageID);
  };

  updateOrder: MerchantosProductImages['updateOrder'] = () => {
    let order = 0;
    let currentImage = this.images.head;
    const newImageArray = [];
    let image;

    while (currentImage !== null) {
      currentImage.updateOrder(order);
      // eslint-disable-next-line no-loop-func
      image = _.findWhere(this.imageArray, { id: currentImage?.id });

      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      image.ordering = order;
      newImageArray.push(image);
      currentImage = currentImage.next;
      order += 1;
    }

    // @ts-expect-error ts-migrate(2322) FIXME: Type '(ImageInfo | undefined)[]' is not assignable... Remove this comment to see the full error message
    this.imageArray = newImageArray;
    if (this.options.type === 'Item') {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
      window.merchantos.itemCaching.setImageCache(this.id, this.imageArray);
    }
  };
}
